import Bridge from "./Bridge";

export default new Bridge();